import { render, staticRenderFns } from "./PublicDDSReport.vue?vue&type=template&id=5412e577&scoped=true"
import script from "./PublicDDSReport.vue?vue&type=script&lang=js"
export * from "./PublicDDSReport.vue?vue&type=script&lang=js"
import style0 from "./PublicDDSReport.vue?vue&type=style&index=0&id=5412e577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5412e577",
  null
  
)

export default component.exports